import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminRoute from '../components/AdminRoute';
import RoleBasedRoute from '../components/RoleBasedRoute';
import DriversList from '../pages/drivers/DriversList';
import DriverDetail from '../pages/drivers/DriverDetail';
import DriverForm from '../components/drivers/DriverForm';
import DriverStatus from '../pages/drivers/DriverStatus';

const DriverRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Driver status page - accessible to drivers only */}
      <Route
        path="status"
        element={
          <RoleBasedRoute allowedRoles={['driver']}>
            <DriverStatus />
          </RoleBasedRoute>
        }
      />
      {/* Admin routes - restricted to admins only */}
      <Route
        path="/"
        element={
          <AdminRoute>
            <DriversList />
          </AdminRoute>
        }
      />
      <Route
        path="new"
        element={
          <AdminRoute>
            <DriverForm />
          </AdminRoute>
        }
      />
      <Route
        path=":id"
        element={
          <AdminRoute>
            <DriverDetail />
          </AdminRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <AdminRoute>
            <DriverForm isEdit />
          </AdminRoute>
        }
      />
    </Routes>
  );
};

export default DriverRoutes;
